.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  max-width: 720px;
  margin: 0 auto;
  padding: var(--tuna-spacing-4);
}

.welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-6);
  text-align: center;
}

.intro {
  margin: 0;
  max-width: 420px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}
